import { Lang } from '../types';

/**
 * Traducción al inglés de las etiquetas (tags) de experiencia y formación y
 * del stack tecnológico. En los datos se escriben en español; el tipo
 * Etiqueta solo admite las claves de este diccionario, así que una etiqueta
 * nueva sin su traducción no compila y el CV inglés no se queda atrás.
 */
const ETIQUETAS = {
  '100M€': '€100M',
  '100M€ NEOTEC': '€100M NEOTEC',
  'Aceleración': 'Acceleration',
  'Advisory Board': 'Advisory Board',
  'Agentes de IA': 'AI Agents',
  'Agile': 'Agile',
  'Android': 'Android',
  'AWS': 'AWS',
  'Azure': 'Azure',
  'Balanced Scorecard': 'Balanced Scorecard',
  'Biometría': 'Biometrics',
  'Brasil': 'Brazil',
  'Calidad': 'Quality',
  'Capital Riesgo': 'Private Equity',
  'CdA': 'Board',
  'CdA ADER': 'ADER Board',
  'CIO': 'CIO',
  'Cloud': 'Cloud',
  'Cloud (AWS / Azure)': 'Cloud (AWS / Azure)',
  'Consejero': 'Board Director',
  'Consultoría': 'Consulting',
  'Contabilidad': 'Accounting',
  'CRM': 'CRM',
  'Cumplimiento normativo': 'Regulatory compliance',
  'Data Lake': 'Data Lake',
  'Data Lakes': 'Data Lakes',
  'Dirección General': 'General Management',
  'Docker': 'Docker',
  'Due-Diligence': 'Due Diligence',
  'Electrónica': 'Electronics',
  'Emprendimiento': 'Entrepreneurship',
  'Energías Renovables': 'Renewable Energy',
  'Eólica': 'Wind Power',
  'ERP': 'ERP',
  'Estrategia': 'Strategy',
  'EU AI Act': 'EU AI Act',
  'Fashion Tech': 'Fashion Tech',
  'FinTech': 'FinTech',
  'FMCG': 'FMCG',
  'Fuerzas de Seguridad': 'Law Enforcement',
  'Fundador': 'Founder',
  'Fusión': 'Merger',
  'Fusiones': 'Mergers',
  'GIS': 'GIS',
  'Git': 'Git',
  'Gobernanza de IA': 'AI Governance',
  'Gobierno Corporativo': 'Corporate Governance',
  'HealthTech': 'HealthTech',
  'HTML / CSS': 'HTML / CSS',
  'IA': 'AI',
  'IA / LLMs': 'AI / LLMs',
  'IA aplicada': 'Applied AI',
  'IA generativa': 'Generative AI',
  'IA generativa / LLM': 'Generative AI / LLM',
  'Identidad Digital': 'Digital Identity',
  'Industria': 'Industry',
  'Ingeniería': 'Engineering',
  'Inteligencia Artificial': 'Artificial Intelligence',
  'Innoliva': 'Innoliva',
  'Innovación Abierta': 'Open Innovation',
  'Internacional': 'International',
  'Internacionalización': 'Internationalisation',
  'Inversión': 'Investment',
  'iOS': 'iOS',
  'JavaScript': 'JavaScript',
  'Laravel / PHP': 'Laravel / PHP',
  'Layout': 'Layout',
  'Lean': 'Lean',
  'Licitaciones': 'Public Tenders',
  'Liderazgo': 'Leadership',
  'M&A': 'M&A',
  'MCP': 'MCP',
  'Management': 'Management',
  'Marca blanca': 'White Label',
  'Medioambiente': 'Environment',
  'Mobile': 'Mobile',
  'Multinacional': 'Multinational',
  'n8n': 'n8n',
  'Next.js / React': 'Next.js / React',
  'Operaciones': 'Operations',
  'Organización Industrial': 'Industrial Organisation',
  'Pascual': 'Pascual',
  'PHP': 'PHP',
  'Power BI': 'Power BI',
  'Procesos': 'Processes',
  'Python': 'Python',
  'RAG': 'RAG',
  'React': 'React',
  'Reestructuración': 'Restructuring',
  'RegTech': 'RegTech',
  'Reingeniería': 'Reengineering',
  'Retail': 'Retail',
  'RPA': 'RPA',
  'SaaS': 'SaaS',
  'Salud': 'Healthcare',
  'SAP': 'SAP',
  'Scrum': 'Scrum',
  'Sector Público': 'Public Sector',
  'Software': 'Software',
  'Sovereign Cloud': 'Sovereign Cloud',
  'Spin-offs': 'Spin-offs',
  'SQL / MySQL / Supabase': 'SQL / MySQL / Supabase',
  'SQL / Supabase': 'SQL / Supabase',
  'Startup': 'Startup',
  'Swift': 'Swift',
  'Tableau': 'Tableau',
  'Tableau / Power BI': 'Tableau / Power BI',
  'Telecom': 'Telecom',
  'Telemedicina': 'Telemedicine',
  'Transformación Digital': 'Digital Transformation',
  'Turnaround': 'Turnaround',
  'TypeScript': 'TypeScript',
  'Universidad': 'University',
  'VC 9M€': '€9M VC',
  'Ventas': 'Sales',
  'Venture Capital': 'Venture Capital',
};

export type Etiqueta = keyof typeof ETIQUETAS;

export const etiqueta = (tag: Etiqueta, lang: Lang): string =>
  lang === 'es' ? tag : ETIQUETAS[tag];

/** "2026-Actualidad" → "2026-Present" en inglés */
export const periodo = (p: string, lang: Lang): string =>
  lang === 'es' ? p : p.replace(/Actualidad/g, 'Present');
